import Icon from '@ant-design/icons'
import React, { FC, SVGProps } from 'react'
import './index.less'

interface DropdownRowProps {
  icon?: FC<SVGProps<SVGSVGElement>>
  label?: string
}

export const DropdownRow = ({ icon, label }: DropdownRowProps) => {
  return (
    <div className="dropdownRow">
      <div className="dropdownRow__icn">
        <Icon component={icon} />
      </div>
      <span>{label}</span>
    </div>
  )
}
